import React from "react";
import Section from "./Section";

function About() {
  return (
    <Section id="about" label="About">
      <div className="max-w-[58ch] [text-wrap:pretty] space-y-4 text-base leading-[1.65] md:text-[17px] text-body">
        <p className="[text-wrap:balance] text-2xl md:text-[28px] leading-[1.2] tracking-[-0.02em] text-fg font-semibold">
          I like clean, modular code that solves real problems.
        </p>
        <p>
          My main focus is image processing and Python: computer vision, data pipelines, and tools
          that make sense of visual data. I fell in love with programming early and have been
          building things ever since.
        </p>
        <p>
          On the side I build{" "}
          <a
            href="#work"
            className="text-fg underline decoration-leaf/40 underline-offset-4 hover:decoration-leaf"
          >
            web and mobile apps
          </a>
          , mostly as interfaces around the things I work on.
        </p>
        <p>
          Away from the keyboard you'll find me gaming, on the volleyball court, or travelling
          somewhere new.
        </p>
      </div>
    </Section>
  );
}

export default About;
